export default {
  taskRecord: {
    title: "Recompensas de tareas",
    loading: "Cargando...",
    empty: "Sin recompensas",
    completed: "Esta tarea ya fue completada",
    desc: "Completa tareas para obtener recompensas",
    close: "Cerrar",
    add: "Agregar",
    addEmail: "Agregar Correo",
    addPhoneNumber: "Agregar Teléfono",
    addBirthday: "Agregar Fecha de Nacimiento",
    downloadNow: "Descargar Ahora",
    phone: "Teléfono",
    email: "Correo electrónico",
    bank: "Tarjeta bancaria",
    birthday: "Fecha de nacimiento",
    download: "Descargar",
    downloadApp: "Descargar APP",
    registerBonus: "Bono de Registro",
    firstInviteBonus: "Bono de Primera Invitación",
    invite: "Invitar",
    inviteNow: "Invitar Amigos",
    go: "Ir",
    receive: "Reclamar",
    received: "Reclamado",
    task: "Tarea",
	claimRewards: 'Reclamar Recompensas',
    receiveSuccess: 'Recompensa reclamada con éxito',
    receiveFail: 'No se pudo reclamar la recompensa'
  }
};
